// extracted by mini-css-extract-plugin
export default {"page":"EditWishlist_page__g1yd8","container":"EditWishlist_container__rZ-ZH"};